(function ($) {
	"use strict";

	/*=============================================
	=       Sticky Menu         =
	=============================================*/
	
	$(window).on('scroll', function () {
		if ($(this).scrollTop() > 350) {
			$('.header-wrapper .menu-header').addClass('sticky');
			if ( $(window).width() <= 1024 ) {
				$(".mm-ocd").css({ top: "58px" });
			}
		} else {
			$('.header-wrapper .menu-header').removeClass('sticky');
			if ( $(window).width() <= 1024 ) {
				$(".mm-ocd").css({ top: "100px" });
			}
			if ( $(window).width() <= 768 ) {
				$(".mm-ocd").css({ top: "120px" });
			}
			if ( $(window).width() <= 576 ) {
				$(".mm-ocd").css({ top: "100px" });
			}
		}
	});
	/*=============================================
	=       Scroll Top Button - Show        =
	=============================================*/
	var $scrollTop = $('#scroll-top');

	$(window).on('load scroll', function() {
		if ( $(window).scrollTop() >= 400 ) {
			$scrollTop.addClass('show');
		} else {
			if ( $scrollTop.hasClass('show') ) {
				$scrollTop.removeClass('show');
			}
		}
	});

	// On click animate to top
	$scrollTop.on('click', function (e) {
		$('html, body').animate({
			'scrollTop': 0
		}, 400);
		e.preventDefault();
	});

	/*=============================================
	=       Overlay mega menu         =
	=============================================*/
	$(".menu-header .nav-item.dropdown").hover(function(){
		$('#menu_overlay').toggle();
		$(".header-wrapper").toggleClass('hover-menu');
	});
	/*=============================================
	=       Slider Slick          =
	=============================================*/
		function minTwoDigits(n) {
			return (n < 10 ? '0' : '') + n;
		}
		var slideCount = $('.slideCount');
		var slickSlide = $('.slickslider');

		slickSlide.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
			//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
			var i = (currentSlide ? currentSlide : 0) + 1;
			$('.slideCount').html('<span class="slideCountItem">' + minTwoDigits(i) + '</span> ' + '/' + ' <span class="slideCountAll">' + minTwoDigits(slick.slideCount) + '</span>');
		});
		var num = $('.slickslider .slickitem').length;
		if (num > 3){
			slickSlide.slick({
				centerMode: true,
				centerPadding: '0px',
				slidesToShow: 3,
				responsive: [
					{
					  breakpoint: 740,
					  settings: {
						centerMode: true,
						centerPadding: '70px',
						slidesToShow: 1
					  }
					}
				]
			});
		}else {
			if (window.matchMedia("(max-width: 768px)").matches){
				slickSlide.slick({
					centerMode: true,
					centerPadding: '0px',
					slidesToShow: 3,
					responsive: [
						{
						  breakpoint: 740,
						  settings: {
							centerMode: true,
							centerPadding: '70px',
							slidesToShow: 1
						  }
						}
					]
				});
			}
		}

		// var slideCountblog = $('.list-post-blog .slideCount');
		// var slickblog = $('.list-post-blog .slider-postblog');

		// slickblog.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
		// 	//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
		// 	var i = (currentSlide ? currentSlide : 0) + 1;
		// 	$('.slideCount').html('<span class="slideCountItem">' + minTwoDigits(i) + '</span> ' + '/' + ' <span class="slideCountAll">' + minTwoDigits(slick.slideCountblog) + '</span>');
		// });

		// slickblog.slick({
		// 	centerMode: true,
		// 	centerPadding: '0px',
		// 	slidesToShow: 2,
		// 	responsive: [
		// 		{
		// 		  breakpoint: 740,
		// 		  settings: {
		// 			centerMode: true,
		// 			centerPadding: '70px',
		// 			slidesToShow: 1
		// 		  }
		// 		}
		// 	]
		// });


		var $slider = $('.slider-home');

		if ($slider.length) {
		  var currentSlide;
		  var slidesCount;
		  var sliderCounter = document.createElement('div');
		  sliderCounter.classList.add('slideCount2');
		  
		  var updateSliderCounter = function(slick, currentIndex) {
			currentSlide = slick.slickCurrentSlide() + 1;
			slidesCount = slick.slideCount;
			// $(sliderCounter).text(currentSlide + '/' +slidesCount)
			$(sliderCounter).html('<span class="slideCountItem">' + minTwoDigits(currentSlide) + '</span> ' + '/' + ' <span class="slideCountAll">' +  minTwoDigits(slidesCount)  + '</span>');
		  };
		
		  $slider.on('init', function(event, slick) {
			$slider.append(sliderCounter);
			updateSliderCounter(slick);
		  });
		
		  	$slider.on('afterChange', function(event, slick, currentSlide) {
				updateSliderCounter(slick, currentSlide);
			});
		
		  	$slider.slick({
				slidesToShow: 1,
				autoplay: false,
				fade: true,
				infinite: false,
				adaptiveHeight:true,
				autoplay: true,
  				autoplaySpeed: 3000,
			});	
		}





		/* Slider Post blog*/
		var $slider = $('.slider-postblog');
		if ($slider.length) {
			var currentSlide;
			var slidesCount;
			var slideCountBlog = $('.slideCountBlog');
			
			var updateSliderCounter = function(slick, currentIndex) {
				currentSlide = slick.slickCurrentSlide() + 1;
				slidesCount = slick.slideCount;
				$(slideCountBlog).html('<span class="slideCountItem">' + minTwoDigits(currentSlide) +'</span> '+ '/' + '<span class="slideCountAll">' + minTwoDigits(slidesCount) +'</span> ')
			};
			$slider.on('init afterChange', function(event, slick, currentSlide) {
				updateSliderCounter(slick, currentSlide);
			});

			$slider.slick({
				slidesToShow: 2,
				responsive: [
					{
					  breakpoint: 740,
					  settings: {
						slidesToShow: 1
					  }
					}
				]
			});
		}	
		
  		// Call the below function
  		if($(".ooo-instagram").length){
			waitForElementToDisplay(".instaimage",function(){
				$('.insta-home').slick({
						centerMode: true,
						centerPadding: '0 0 60px',
						slidesToShow: 3,
						arrows: false,

						responsive: [
							{
							breakpoint: 768,
							settings: {
								arrows: false,
								centerMode: false,
								centerPadding: '40px',
								slidesToShow: 3
							}
							},
							{
							breakpoint: 480,
							settings: {
								arrows: false,
								centerMode: false,
								centerPadding: '0px',
								slidesToShow: 2
							}
							}
						]
					});
			},500,50000);
		}
		function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
			var startTimeInMs = Date.now();
			(function loopSearch() {
			  if (document.querySelectorAll(selector).length > 1) {
				callback();
				return;
			  }
			  else {
				setTimeout(function () {
				  if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
					return;
				  loopSearch();
				}, checkFrequencyInMs);
			  }
			})();
		  }
		if($(window).width() > 1024){
			$('.nav-item.dropdown').hover(
				function() { 
					$('.mega-menu .slider-list-menu').slick({
						slidesToShow: 8,
						slidesToScroll: 1,
						infinite:true,
						arrows: true,
						prevArrow:"<button type='button' class='slick-prev pull-left absolute left-0 top-2/4 -translate-y-1/2 z-10 hover:opacity-60'><span class='icon-right text-lg font-semibold z-10'></span></button>",
						nextArrow:"<button type='button' class='slick-next pull-right absolute right-0 top-2/4 -translate-y-1/2 z-10 hover:opacity-60'><span class='icon-right text-lg font-semibold z-10'></span></button>"
					});
				},
				function() { 
					$('.mega-menu .slider-list-menu').slick('unslick');
				}
			);
		}

		/*=============================================
		=       addtocart show panier          =
		=============================================*/
		$('.hollis-addtocart').on('click',function(){
			UIkit.offcanvas('#offcanvas-flip').toggle();
			var myTimeOut;
			myTimeOut = setTimeout("UIkit.offcanvas('#offcanvas-flip').toggle();", 3000);
			$('.uk-offcanvas-slide').mouseover( function () {
				clearTimeout(myTimeOut);
			});
		});


		/*=============================================
		=       Menu item on hover          =
		=============================================*/

		// $(".header-wrapper .nav-item.dropdown").hover(
		// 	function () {
		// 	$(".header-wrapper").addClass('hover-menu');
		// 	}, 
		// 	function () {
		// 	$(".header-wrapper").removeClass('hover-menu');
		// 	}
		// );

		/*=============================================
		=  Open Page Reset Password Customer Account   =
		=============================================*/

		if($(".template-customers-login").length){
			$('.login #RecoverPassword').on('click',function(){
				$('.template-customers-login .login').addClass('hidden');
				$('.template-customers-login .recover').removeClass('hidden');
			});
			$('#RecoverPasswordForm #HideRecoverPasswordLink').on('click',function(){
				$('.template-customers-login .login').removeClass('hidden');
				$('.template-customers-login .recover').addClass('hidden');
			});
			if (location.hash === "#recover") {
				$('.template-customers-login .login').addClass('hidden');
				$('.template-customers-login .recover').removeClass('hidden');
			}else{
				$('.template-customers-login .login').removeClass('hidden');
				$('.template-customers-login .recover').addClass('hidden');
			}
		}
		/*=============================================
		=       Menu Mmenujs mobile          =
		=============================================*/

		var menu = new MmenuLight(
			document.querySelector( '#menu' ),
		);
		if ( $(window).width() <= 1024 ) {

			document.addEventListener(
				"DOMContentLoaded", () => {
					// const menu = new MmenuLight(
					// 	document.querySelector( "#menu" )
					// );
		
					const drawer = menu.offcanvas();
	
					document.querySelector( '.menu-header a[href="#menu"]' )
					.addEventListener( 'click', ( evnt ) => {
						evnt.preventDefault();
						drawer.open();
						console.log('opened');
						$( ".search-dropdown" ).insertBefore( $( "#menu" ) );
					});
					document.querySelector( '.menu-header a[href="#page"]' )
					.addEventListener( 'click', ( evnt ) => {
						evnt.preventDefault();
						drawer.close();
					});	
				}
			);
		}	
		

		$('.uk-search-input').on('input', function () {
			$('.icon-croix-rond').toggle(this.value.length > 3);
			$('.mobile-search').toggle(this.value.length > 3);
		});
		$('.search-dropdown .uk-search .icon-croix-rond').on('click', function () {
			$('.menu-header .mobile-search').toggle(); 
		});
		

		var navigator = menu.navigation({
			 selectedClass: 'Selected',
			 slidingSubmenus: true,
			// theme: 'dark',
			title: ' '
		});

		var drawer = menu.offcanvas({
			// position: 'left'
		});
	
	/*=============================================
	=       toggle menu footer          =
	=============================================*/
 
	    var $collapsed = this;
		$('.menu-footer h3', $collapsed).on('click', function (e) {
			e.preventDefault;
			$(this).closest('.menu-footer').toggleClass('open');
		});

		$('.menu-header .btn--link').click(function(){
				$('.menu-header .search-dropdown').slideToggle("400");
				$(".header-wrapper").toggleClass('hover-menu');        
		});
		$('.search-dropdown .uk-search button').click(function(){
			$('.menu-header .search-dropdown').slideUp("400");
			$(".header-wrapper").removeClass('hover-menu');        
		});




	/*=============================================
	=       Tronque texte page categorie          =
	=============================================*/
 
    var maxLength = 85; 

    $(".bloc-texte .content").each(function(){
        var myStr = $(this).text();
        if($.trim(myStr).length > maxLength){
            var newStr = myStr.substring(0, maxLength);
            var removedStr = myStr.substring(maxLength, $.trim(myStr).length);
            $(this).empty().html(newStr);
            $(this).append('...<a href="javascript:void(0);" class="read-more">Lire plus</a>');
            $(this).append('<span class="more-text">' + removedStr + '</span>');
        }
    });
    $(".bloc-texte .content a").click(function(){
        $(this).siblings(".more-text").contents().unwrap();
        $(this).remove();
    });

    /*=============================================
	=     simpl-List to toggle-List in Mobile    =
	=============================================*/ 

	$(".toggleMobile").click(function() {
	   $(this).toggleClass('active') 
	   $(this).next().toggle();
	}); 
 	
   
	/*=============================================
	=       Pastilles composition page produit  =
	=============================================*/ 

    $('#tab-1 .pastilles li:not(:first)').addClass('inactive');
	$('#tab-1 .descriptions .desc').hide();
	$('#tab-1 .descriptions .desc:first').show();

	$('#tab-2 .pastilles li:not(:first)').addClass('inactive');
	$('#tab-2 .descriptions .desc').hide();
	$('#tab-2 .descriptions .desc:first').show();
	    
	$('#tab-1 .pastilles li').click(function(){
	    var t = $(this).attr('id');
	  if($(this).hasClass('inactive')){ //this is the start of our condition 
	    $('#tab-1 .pastilles li').addClass('inactive');           
	    $(this).removeClass('inactive');
	    
	    $('#tab-1 .descriptions .desc').hide(); 
	    $('#'+ t + 'c').fadeIn('slow');
	 }
	});

	$('#tab-2 .pastilles li').click(function(){
	    var t = $(this).attr('id');
	  if($(this).hasClass('inactive')){ //this is the start of our condition 
	    $('#tab-2 .pastilles li').addClass('inactive');           
	    $(this).removeClass('inactive');
	    
	    $('#tab-2 .descriptions .desc').hide();
	    $('#'+ t + 'f').fadeIn('slow'); 
	 }
	});
 	
 	/*=============================================
	=        CTA Ajout au panier sticky          =
	=============================================*/
	var heightBox = $('.template-product .content .box-product').height()
	$('.template-product .content .box-product').css('min-height', heightBox);

	var topDist = $(".template-product .content .add-to-cart").offset();
	// if (window.matchMedia("(min-width: 768px)").matches){
		
	// } else {	
	// 	var topDist = $(".content .add-to-cart").offset();
	// }	
 	$(document).on('scroll', function () {
		if ( $('body').hasClass('template-product')) {
			var scroll = $(this).scrollTop();
			console.log(scroll)
			console.log(topDist.top)
			if (scroll > topDist.top ) {
				$('#product .info-product .box-product-inner').addClass('fixed');
			} else {
				$('#product .info-product .box-product-inner').removeClass('fixed');
			}
		}
        
    });


	// if (window.matchMedia("(min-width: 768px)").matches){
	// 	$(document).scroll(function () {
	// 		var scroll = $(this).scrollTop();
	// 		var topDist = $(".section-reassurance").position();
	// 		if (scroll > topDist.top) {
	// 			$('#product .info-product .right').addClass('fixed');
	// 		} else {
	// 			$('#product .info-product .right').removeClass('fixed');
	// 		}
	// 	});
	// }else {	
	// 	var $el = $('#product .info-product .content .right .add-to-cart');
	// 	if ($el.length) {
	// 	  var heightbloc = $el.outerHeight();
	// 	  var stickyHeaderTop = $('#product  .info-product .left').offset().top + heightbloc  ;
	// 	  $(window).scroll(function(){
	// 		if( $(window).scrollTop() > stickyHeaderTop ) { 
	// 			$('#product .info-product .right').addClass('fixed');
	// 		} else {
	// 			$('#product .info-product .right').removeClass('fixed');
	// 		}
	// 	  });
	// 	}
	// }
    /*=============================================
	=        Quantite         =
	=============================================*/
 
 	$(".quantity-adder .add-action").click( function(){
		if( $(this).hasClass('add-up') ) {  
			$("[name=quantity]",'.quantity-adder').val( parseInt($("[name=quantity]",'.quantity-adder').val()) + 1 );
		}else {
			if( parseInt($("[name=quantity]",'.quantity-adder').val())  > 1 ) {
				$("input",'.quantity-adder').val( parseInt($("[name=quantity]",'.quantity-adder').val()) - 1 );
			}
		}
	} );

	/*=============================================
	=                  Accordion                =
	=============================================*/
	 
	$('.accordionjs').accordionjs();
	 
	/*=============================================
	=       uikit change tabs on hover  =
	=============================================*/ 

	var switcherElement = $('.section-blog .uk-tab-right');
	$('.section-blog .uk-tab-right li').on('mouseover', function(e){
		var i = $(this).index();
		UIkit.tab(switcherElement).show(i);
		e.preventDefault();
	});

	 /*=============================================
	=       Tabs  =
	=============================================*/ 

    $('.nav-tab').click(function(e) {
	  //Toggle tab link
	  $(this).addClass('nav-tab-active').siblings().removeClass('nav-tab-active');

	  //Toggle target tab
	  $($(this).attr('href')).addClass('active').siblings().removeClass('active');
	  return false;
	});


})(jQuery);
